import { createSlice } from '@reduxjs/toolkit'
import {
  Language_IT,
  Language_EN,
  Language_ES,
  Language_FR,
  IsLoadConfigurationAction,
  IsSaveConfigurationAction,
  IsSaveDefaultConfigurationsAction,
  IsDeleteConfigurationAction,
  IsRenameConfigurationAction,
  configurationLanguage,
  imgMissingIt,
  imgNotFoundIt,
  imgMissingEn,
  imgNotFoundEn,
} from '../Constants/Configuration'
import { TranslationKeys } from '../Constants/TranslationKeys'
import { WorkSpaces } from '../Constants/WorkSpace'
import {
  decryptLocalStorageValue,
  encryptLocalStorageValue,
  getStorageValue,
  removeStorageValue,
  setStorageValue,
} from '../Helpers/ConfigurationHelper'

const missingImgsIt = {
  [TranslationKeys.missingImgPath]: imgMissingIt,
  [TranslationKeys.notFoundImgPath]: imgNotFoundIt,
}

const missingImgsEn = {
  [TranslationKeys.missingImgPath]: imgMissingEn,
  [TranslationKeys.notFoundImgPath]: imgNotFoundEn,
}

const missingImgsEs = {
  [TranslationKeys.missingImgPath]: imgMissingEn,
  [TranslationKeys.notFoundImgPath]: imgNotFoundEn,
}

const missingImgsFr = {
  [TranslationKeys.missingImgPath]: imgMissingEn,
  [TranslationKeys.notFoundImgPath]: imgNotFoundEn,
}

const languageExtras = {
  [Language_IT]: missingImgsIt,
  [Language_EN]: missingImgsEn,
  [Language_ES]: missingImgsEs,
  [Language_FR]: missingImgsFr,
}

export const languageSlice = createSlice({
  name: 'language',
  initialState: {
    value: {},
    current: Language_IT,
    missingImg: { ...missingImgsIt },
  },
  reducers: {
    switchLanguage: (state, action) => {
      const extra = languageExtras[action.payload]

      if (extra) {
        state.current = action.payload
        state.missingImg = { ...extra }
      } else {
        state.current = Language_IT
        state.missingImg = { ...missingImgsIt }
      }
    },
    loadLanguage: (state, action) => {
      state.value = { ...action.payload }
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(IsLoadConfigurationAction, (state, action) => {
        const stored = decryptLocalStorageValue(
          action.payload.configurationName + configurationLanguage,
          action.payload.user,
          action.payload.serverConfig,
        )

        if (stored) {
          const extra = languageExtras[stored]
          if (extra) {
            state.current = stored
            state.missingImg = { ...extra }
          } else {
            state.current = Language_IT
            state.missingImg = { ...missingImgsIt }
          }
        }
      })
      .addMatcher(IsSaveConfigurationAction, (state, action) => {
        encryptLocalStorageValue(
          action.payload.currentConfiguration + configurationLanguage,
          state.current,
          action.payload.user,
          action.payload.serverConfig,
        )
      })
      .addMatcher(IsSaveDefaultConfigurationsAction, (state, action) => {
        if (action.payload.publicWorkspace) {
          const space = WorkSpaces[action.payload.publicWorkspace]
          encryptLocalStorageValue(
            action.payload.publicWorkspace + configurationLanguage,
            space[configurationLanguage.substring(1)],
            action.payload.user,
            action.payload.serverConfig,
          )
        } else {
          for (const [key, value] of Object.entries(WorkSpaces)) {
            encryptLocalStorageValue(
              key + configurationLanguage,
              value[configurationLanguage.substring(1)],
              action.payload.user,
              action.payload.serverConfig,
            )
          }
        }
      })
      .addMatcher(IsDeleteConfigurationAction, (state, action) => {
        removeStorageValue(
          action.payload.configurationName + configurationLanguage,
          action.payload.user,
          action.payload.serverConfig,
        )
      })
      .addMatcher(IsRenameConfigurationAction, (state, action) => {
        const value = getStorageValue(
          action.payload.before + configurationLanguage,
          action.payload.user,
          action.payload.serverConfig,
        )

        setStorageValue(
          action.payload.after + configurationLanguage,
          action.payload.user,
          action.payload.serverConfig,
          value,
        )

        removeStorageValue(
          action.payload.before + configurationLanguage,
          action.payload.user,
          action.payload.serverConfig,
        )
      })
  },
})

// Action creators are generated for each case reducer function
export const { switchLanguage, loadLanguage } = languageSlice.actions

export default languageSlice.reducer
